import {compareAPPVersion, generateUserAgentValues} from '@financial/app-js-interfaces'

import {getRedirectUrlFromAuthError, isAuthError} from '$utils/auth'
import {
    getRedirectPayAppAuthError,
    getRedirectPayappUrlFromMfaError,
    getRedirectUrlFromMfaError,
    isMfaSessionError,
    isPayAppOneDeviceInvalidError,
} from '$utils/mfa'

import type {AxiosError} from 'axios'
import type {GetServerSidePropsContext, Redirect} from 'next'

export const catchAxiosErrorOnTanstackQuery = <T extends boolean | Redirect>(
    error: AxiosError,
    {
        currentUrl,
        userAgent,
        ctx,
        redirect,
    }: {
        currentUrl: string
        userAgent: string
        ctx?: GetServerSidePropsContext
        redirect(redirectUrl: string): T
    },
) => {
    let redirectUrl: string | undefined

    const {isMobile, isPayApp = false, appVersion = ''} = generateUserAgentValues(userAgent)

    if (isAuthError(error)) {
        /**
         * authInfo 에러
         */
        redirectUrl = getRedirectUrlFromAuthError(error, currentUrl, isMobile)
    } else if (isPayAppOneDeviceInvalidError(error)) {
        /**
         * payAppOneDeviceCheck 에러
         */
        redirectUrl = getRedirectPayAppAuthError(error, ctx)
    } else if (isMfaSessionError(error)) {
        /**
         * mfa 인증 에러
         */
        const isSupportPayapp = isPayApp && appVersion && compareAPPVersion('2.1.0', '<=', appVersion)

        redirectUrl = isSupportPayapp
            ? getRedirectPayappUrlFromMfaError(error, ctx) || ''
            : getRedirectUrlFromMfaError(error, ctx) || ''
    }

    if (redirectUrl) {
        return redirect(redirectUrl)
    }
}
